module.exports = __webpack_public_path__ + "static/media/lightbulb-slash.fe609cef.svg";